import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

class WidgetTopBrands extends Component {

    constructor({ stores, fromDate, toDate, widget }) {
        super();
        this.state = {
            stores: stores,
            fromDate: fromDate, 
            toDate: toDate,
            widget: widget,
            brands: []
        }
    }

    async componentDidMount() {
        this.loadData(this.state.stores, this.state.fromDate, this.state.toDate, this.state.widget);
    }

    loadData(stores, fromDate, toDate, widget) {

        this.props.getBrandWiseSales(this.props.user.user.RegistrationID, stores, fromDate, toDate, widget.WidgetOptionTopX, widget.WidgetOptionAmtOrQty)
            .then((result) => {
                this.setState({ brands: result.searchResult, totalItemsCount: result.totalItemsCount })
            });
    }

    componentWillReceiveProps({ stores, fromDate, toDate, widget }) {
        this.loadData(stores, fromDate, toDate, widget);
    }

    render() {
        return  <div className="dashboard-box" >
            <div className="dashboard-box-header">
                <div className="dashboard-box-title left">Brand</div>
                <div className="right">
                    <button type="submit" className="btn pull-right btn-flat btn-default"
                        onClick={() => this.props.history.push({
                            pathname: "/home/reports/brandwise",
                            state: {
                                action: 'Sales Dashboard',
                                searchTransactionFromDate: this.state.fromDate,
                                searchTransactionToDate: this.state.toDate,
                                storeList: this.state.stores
                            }
                        })}>View More</button>
                    </div>
            </div>
            <div className="dashboard-box-body">
                <div className="table-responsive scroll2">
                    {this.state.brands.length > 0 && <table className="table table-striped no-margin">
                        <thead>
                            <tr>
                                <th>Brand</th>
                                <th style={{ textAlign: "right" }}>Qty</th>
                                <th style={{ textAlign: "right" }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.brands.map((brand, index) =>
                                <tr key={"brands_" + index}>
                                    <td>{brand.name}</td>
                                    <td style={{ textAlign: "right" }}>{brand.total_qty}</td>
                                    <td style={{ textAlign: "right" }}>{brand.total_sales}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>}
                    {this.state.brands.length === 0 && "No records found"}
                </div>
            </div>
    </div>}
}

export default WidgetTopBrands